"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_error_boundary_1 = require("react-error-boundary");
var react_query_1 = require("react-query");
var constants_1 = require("../../../constants");
var dashboard_service_1 = __importDefault(require("../../../services/dashboard/dashboard.service"));
var utilities_1 = require("../../../utilities");
function useFetchSummaryCount() {
    var showBoundary = (0, react_error_boundary_1.useErrorBoundary)().showBoundary;
    return (0, react_query_1.useQuery)(constants_1.GET_SUMMARY_COUNT, function () { return dashboard_service_1.default.getSummaryCount(); }, {
        staleTime: 1000 * 60 * 30,
        onError: function (error) {
            (0, utilities_1.handleError)(error);
            showBoundary(error);
        }
    });
}
exports.default = useFetchSummaryCount;
